import { render, staticRenderFns } from "./ScientificDegreeBtns.vue?vue&type=template&id=e6835610&"
import script from "./ScientificDegreeBtns.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports